import React, { useState, useEffect, useReducer, useRef } from "react";
import MUIDataTable from "mui-datatables";
import {
  Grid,
  Button,
  TextField,
  SwipeableDrawer,
  TablePagination,
  Backdrop,
  CircularProgress,
  Avatar,
  withStyles,
  IconButton,
  Typography
} from "@material-ui/core";
import PageTitle from "../../components/PageTitle";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { toast } from "react-toastify";
//import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import moment from "moment";
import Tooltip from "@material-ui/core/Tooltip";
//import classNames from "classnames";
import { useHistory } from "react-router-dom";
import VendorAvatarIcon from "../../images/svg/vendor_svg_icon.svg"
import FreelancerAvatarIcon from "../../images/svg/freelancer_svg_icon.svg"
import invoice_bill_percentage from "../../images/svg/share_percentage.svg"
import mailSendImg from "../../images/sidebar_icon/mailSend.png";
// import { saveAs } from "file-saver";
// import XlsxPopulate from "xlsx-populate";
import { Autocomplete } from "@material-ui/lab";
import ViewIcon from "@material-ui/icons/Visibility";
import DescriptionIcon from "@material-ui/icons/Description";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { jwtDecode } from "jwt-decode";
import { useForm } from "react-hook-form";
import Notification from "../../components/Notification";
import Status from "../../components/Admin/Status";
import Dialogs from "../../components/Admin/Dialogs";
import Drop from "../../components/Candidates/Drop";
import Reverse from "../../components/Admin/Reverse";
import Actions from "../../components/Candidates/Actions";

import Add from "../../components/Candidates/Add";
import Edit from "../../components/Candidates/Edit";
import View from "../../components/Candidates/View";
import Note from "../../components/Candidates/Note";
import Bar from "../../components/Candidates/Bar";
import Message from "../../components/Candidates/Message";
import ExpandButton from "../../components/Candidates/ExpandButton";
import { IoMailOpenOutline } from "react-icons/io5";

import useStyles from "../../themes/style.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import "react-toastify/dist/ReactToastify.css";
import MatchJDDialog from "../../components/Candidates/MatchJDDialog.js";
import { useResumeDataContext } from '../../context/CandidateDataContext.js'
import Lottie from 'lottie-react'
import lockanimation from '../../images/lootie/animation-lock.json'
import chatSVGicon from '../../images/svg/chat_icon_svg.svg'
import ReactPdfDialog from "../../components/Candidates/ReactPdfDialog.js";
import CPVFormView from "../../components/Candidates/CPVFormView.js";
import FreelancerCandidatesApproval from "../../components/Admin/FreelancerCandidatesApproval.js";
import gold_coin from "../../images/svg/Gold-coin.svg"
import info_icon_svg from "../../images/svg/info_icon_svg.svg"
import DropReasonDialogs from "../../components/Admin/DropReasonDialogs.js";
import VendorStatus from "../vendor/VendorStatus.js";

const positions = [toast.POSITION.TOP_RIGHT];

const RecCoinTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 250,
    fontFamily: "'Inter', sansSerif",
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

export default function Candidates(props) {
  var classes = useStyles();
  const messageRef = useRef();
  const candidate_search = props.location.search;
  const history = useHistory();
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);
  const filterRef = useRef(null);
  const [count, setCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const [userName, setUserName] = useState([]);
  const [clientName, setClientName] = useState([]);
  const [candidateList, setCandidateList] = useState({
    id: "",
    name: "",
    mobile: "",
    message: "",
    rec_name: "",
    rec_mobile_no: "",
  });
  const [state, setState] = useState({
    bottom: false,
    right: false,
  });

  const [candidatesData, setCandidatesData] = useState([]);
  const [search, setSearch] = useState(
    new URLSearchParams(candidate_search).get("search"),
  );
  //Action Button Popper
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const handleMenuClick = (index, event) => {
    if (activeIndex === index) {
      setAnchorEl(null);
      setActiveIndex(null);
    } else {
      setAnchorEl(event.currentTarget);
      setActiveIndex(index);
    }
  };


  const { setResumeParsedData } = useResumeDataContext();
  const [date, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  const months = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  const days = Array.from({ length: 31 }, (_, i) => (i + 1).toString().padStart(2, '0'));
  const years = Array.from(
    { length: 60 },
    (_, i) => moment(new Date()).format("YYYY") - i,
  );

  const [resumePercentage, setResumePercentage] = useState([])
  const [matchLoading, setMatchLoading] = useState(false)

  const lottieRef = useRef(null);
  const handleAnimationMouseHover = () => {
    if (lottieRef.current) {
      lottieRef.current.play();
    }
  };

  const handleAnimationMouseLeave = () => {
    if (lottieRef.current) {
      lottieRef.current.stop();
    }
  }

  const [candidMatchId, setCandidMatchId] = useState("");

  const getRecCoinValue = (requirement) => {
    let recCoinValue = "";
    if (requirement) {
      const cvCoinValue = requirement?.cvShareValue + "/" + requirement.cvInterviewDoneValue + "/" + requirement?.cvJoinValue
      recCoinValue += cvCoinValue
      return recCoinValue
    }
  }

  function handleUse(mobile) {
    history.push("admin_candidates");
    sessionStorage.setItem("use", mobile);

    setState({ ...state, right: true });
    setDataList("ADD");

    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}recruiter/checkCandidateDetailExist`,
      data: {
        mobile: mobile.substring(2),
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {

        setCandidate({
          ...candidate,
          mobile: mobile.substring(2),
          email: response.data.data?.email,
          firstName: response.data.data?.firstName,
          lastName: response.data.data?.lastName,
          skills: response.data.data?.skills,
          experience: response.data.data?.experience,
          location: response.data.data?.currentLocation,
          dob: response.data.data?.dob,
          candidateProcessed: response.data.data?.candidateProcessed,
          native: response.data.data?.nativeLocation,
          preferredLocation: response.data.data?.preferredLocation,
          relevantExperience: response.data.data?.relevantExperience,
          educationalQualification:
            response.data.data?.educationalQualification,
          gender: response.data.data?.gender,
          differentlyAbled: response.data.data?.differentlyAbled,
          currentCtc: response.data.data?.currentCtc,
          expectedCtc: response.data.data?.expectedCtc,
          noticePeriod: response.data.data?.noticePeriod,
          education_gap: response.data.data?.education_gap,
          career_gap: response.data.data?.career_gap,
          document_check: response.data.data?.document_check,
          offer_details: response.data.data?.offer_details,
          reloaction_reason: response.data.data?.reloaction_reason,
          reasonForJobChange: response.data.data?.reasonForJobChange,
          reason: response.data.data?.reason,
          candidateRecruiterDiscussionRecording:
            response.data.data?.candidateRecruiterDiscussionRecording,
          candidateSkillExplanationRecording:
            response.data.data?.candidateSkillExplanationRecording,
          candidateMindsetAssessmentLink:
            response.data.data?.candidateMindsetAssessmentLink,
          candidateAndTechPannelDiscussionRecording:
            response.data.data?.candidateAndTechPannelDiscussionRecording,
          currentCompanyName: response.data.data?.currentCompanyName,
          freeValue:
            decode.isEnableFree === true
              ? "YES"
              : decode.isEnablePaid === true
                ? "NO"
                : "YES",
          panNumber: response.data.data.panNumber,
          linkedInProfile: response.data.data.linkedInProfile,
        });
      }
    });
  }

  const [candidatesNote, setCandidatesNote] = useState([]);
  const [candidatesEdit, setCandidatesEdit] = useState({
    id: "",
    email: "",
    firstName: "",
    lastName: "",
    mobile: "",
    skills: "",
    requirementName: "",
    source: "",
    invoicedDate: "",
    joinedDate: "",
    invoiceValue: "",
    location: "",
    experience: null,
    resume: "",
    document: "",
    photo: "",
    gender: "",
    differentlyAbled: "",
    candidateProcessed: "",
    currentLocation: "",
    preferredLocation: "",
    nativeLocation: "",
    relevantExperience: null,
    currentCtc: null,
    expectedCtc: null,
    dob: "",
    noticePeriod: "",
    reasonForJobChange: "",
    education_gap: "",
    career_gap: "",
    document_check: "",
    offer_details: "",
    reloaction_reason: "",
    reason: "",
    educationalQualification: "",
    alternateMobile: "",
    candidateRecruiterDiscussionRecording: "",
    candidateSkillExplanationRecording: "",
    candidateMindsetAssessmentLink: "",
    candidateAndTechPannelDiscussionRecording: "",
    mainId: "",
    recruiterId: "",
    currentCompanyName: "",
    hideContactDetails: false,
    showAllDetails: null,
    detailsHandler: null,
    panNumber: "",
    linkedInProfile: "",
  });

  const [candidateView, setCandidateView] = useState({
    id: "",
    chatId: "",
    email: "",
    firstName: "",
    lastName: "",
    cc: "",
    mobile: "",
    skills: "",
    clientName: "",
    requirementName: "",
    statusCode: "",
    source: "",
    invoiceValue: "",
    requiremenUniqueId: "",
    candidateUniqueId: "",
    location: "",
    experience: null,
    resume: "",
    document: "",
    photo: "",
    gender: "",
    differentlyAbled: "",
    candidateProcessed: "",
    currentLocation: "",
    preferredLocation: "",
    nativeLocation: "",
    relevantExperience: null,
    currentCtc: null,
    expectedCtc: null,
    dob: "",
    noticePeriod: "",
    reasonForJobChange: "",
    education_gap: "",
    career_gap: "",
    document_check: "",
    offer_details: "",
    reloaction_reason: "",
    reason: "",
    educationalQualification: "",
    alternateMobile: "",
    candidateRecruiterDiscussionRecording: "",
    candidateSkillExplanationRecording: "",
    candidateMindsetAssessmentLink: "",
    candidateAndTechPannelDiscussionRecording: "",
    mainId: "",
    isCandidateCpv: "",
    currentCompanyName: "",
    panNumber: "",
    linkedInProfile: "",
    isSendCpv: false,
  });

  const [page, setPage] = useState(0);
  const [currerntPage, setCurrerntPage] = useState(1);
  const [rowsPerPage] = useState(10);

  const [reducerValue, forceUpdate] = useReducer((x) => x + 1, 0);
  const joiningRef = useRef();
  const invoiceRef = useRef();
  const [file, setFile] = useState([]);
  const [docFile, setDocFile] = useState([]);
  const [profile, setProfile] = useState([]);
  const [assessment, setAssessment] = useState([]);
  const [hideContactDetails, setHideContactDetails] = useState(false);

  const [dataList, setDataList] = useState("ADD");
  const [requirement, setRequirement] = useState([]);
  const [requirementList, setRequirementList] = useState({
    cand1_name: "",
    job1_location: "",
    client1_name: "",
    job1_title: "",
    cand1_skills: "",
    job1_experience: "",
    rec_name: "",
    rec_mobile_no: "",
    req_id: "",
  });

  const [shortList, setShortList] = useState({
    id: "",
    cand_name: "",
    job_id: "",
    job_name: "",
    rec_name: "",
    rec_mobile_no: "",
    cand_mobile: "",
    statusCode: "",
    free: "",
  });

  const [recruitmentList, setRecruitmentList] = useState([]);

  const [validation, setValidation] = useState(false);

  const [addList, setAddList] = useState([]);
  const [source, setSource] = useState([]);
  const [saveOnly, setSaveOnly] = useState("YES");
  const [requirementName, setRequirementName] = useState([]);

  var [errorToastId, setErrorToastId] = useState(null);

  function sendNotification(componentProps, options) {
    return toast(
      <Notification
        {...componentProps}
        className={classes.notificationComponent}
      />,
      options,
    );
  }

  function handleNotificationCall(notificationType, message) {
    var componentProps;

    if (errorToastId && notificationType === "error") return;

    switch (notificationType) {
      case "info":
        componentProps = {
          type: "feedback",
          message: message,
          variant: "contained",
          color: "primary",
        };
        break;
      case "error":
        componentProps = {
          type: "message",
          message: message,
          variant: "contained",
          color: "secondary",
        };
        break;
      default:
        componentProps = {
          type: "shipped",
          message: message,
          variant: "contained",
          color: "success",
        };
    }

    var toastId = sendNotification(componentProps, {
      type: notificationType,
      position: positions[2],
      progressClassName: classes.progress,
      onClose: notificationType === "error" && (() => setErrorToastId(null)),
      className: classes.notification,
    });

    if (notificationType === "error") setErrorToastId(toastId);
  }

  const [phoneValidation, setPhoneValidation] = useState(false);

  const validationSchema = Yup.object().shape({
    requirementId: Yup.string().required("Requirement Name is required"),
    email: Yup.string()
      .email("Email must be a Valid Email Address")
      .required("Email is required"),
    firstName: Yup.string()
      .required("First Name is required")
      .max(255)
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "First Name be Alphanumeric",
      }),
    lastName: Yup.string()
      .max(255)
      .required("Last Name is required")
      .max(255)
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "Last Name be Alphanumeric",
      }),
    mobile: Yup.string()
      .required("Contact Number is required")
      .min(10, "Must be exactly 10 digits")
      .max(10, "Must be exactly 10 digits"),
    skills: Yup.string().required("Skill is required"),
    source: Yup.string().required("Source is required"),
    free: Yup.string().nullable().notRequired(),

    alternateMobile:
      phoneValidation === true
        ? Yup.string()
          .required("Alternate Contact Number is required")
          .min(10, "Must be exactly 10 digits")
          .max(10, "Must be exactly 10 digits")
        : Yup.string(),
    day: Yup.string()
      .required("Day is required")
      .matches(/^(0?[1-9]|[12][0-9]|3[01])$/, "Invalid day"),
    month: Yup.string()
      .required("Month is required")
      .matches(/^(0?[1-9]|1[012])$/, "Invalid month"),
    year: Yup.string()
      .required("Year is required")
      .matches(/^(19|20)\d{2}$/, "Invalid year"),
    gender: Yup.string().nullable().required("Gender is required"),
    linkedInProfile: Yup.string().required("Linked-In profile is required"),
    currentCompanyName: Yup.string().required("Current company name is required"),
    native: Yup.string().required("Native Location is required"),
    location: Yup.string().required("Location is required"),
    preferredLocation: Yup.string().required("Preferred location is required"),
    experience: Yup.number()
      .typeError("Total experience must be a number")
      .required("Total experience is required")
      .transform((_, val) => (val ? Number(val) : null)),
    relevantExperience: Yup.number()
      .typeError("Relevant experience must be a number")
      .required("Relevant experience is required")
      .transform((_, val) => (val ? Number(val) : null)),
    educationalQualification: Yup.string().required("Educational qualification is required"),
    differentlyAbled: Yup.string().required("Differently abled status is required"),
    currentCtc: Yup.number()
      .typeError("Current CTC must be a number")
      .required("Current CTC is required")
      .transform((_, val) => (val ? Number(val) : null)),
    expectedCtc: Yup.number()
      .typeError("Expected CTC must be a number")
      .required("Expected CTC is required")
      .transform((_, val) => (val ? Number(val) : null)),
    noticePeriod: Yup.string().required("Notice period is required"),
    candidateProcessed: Yup.string().required("Candidate processed status is required"),
    education_gap: Yup.string().required("Education gap is required"),
    career_gap: Yup.string().required("Career gap is required"),
    document_check: Yup.string().required("Document check status is required"),
    offer_details: Yup.string().required("Offer details are required"),
    reasonForJobChange: Yup.string().required("Reason for job change is required"),
    reloaction_reason: Yup.string().nullable().notRequired(),
    reason: Yup.string().nullable().notRequired(),
    panNumber: Yup.string().nullable().notRequired(),

    candidateRecruiterDiscussionRecording: Yup.string()
      .nullable()
      .notRequired(),
    candidateSkillExplanationRecording: Yup.string().nullable().notRequired(),
    candidateMindsetAssessmentLink: Yup.string().nullable().notRequired(),
    candidateAndTechPannelDiscussionRecording: Yup.string()
      .nullable()
      .notRequired(),
  });

  const editSchema = Yup.object().shape({
    email:
      candidatesEdit.recruiterId === decode.recruiterId
        ? Yup.string()
          .email("Email must be a Valid Email Address")
          .required("Email is required")
        : Yup.string().email("Email must be a Valid Email Address"),
    firstName: Yup.string()
      .max(255)
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "First Name be Alphanumeric",
      }).when([], {
        is: () => decode.role === "SUBVENDOR" || props.candidatesEdit?.showAllDetails === true,
        then: Yup.string().required("First Name is required"),
        otherwise: Yup.string(),
      }),
    lastName: Yup.string()
      .max(255)
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "Last Name be Alphanumeric",
      }).when([], {
        is: () => decode.role === "SUBVENDOR" || props.candidatesEdit?.showAllDetails === true,
        then: Yup.string().required("Last Name is required"),
        otherwise: Yup.string(),
      }),
    skills: Yup.string().required("Skill is required"),
    source: Yup.string().required("Source is required"),
    experience: Yup.number()
      .typeError("Total experience must be a number")
      .required("Total experience is required")
      .transform((_, val) => (val ? Number(val) : null)),
    location: Yup.string().required("Location is required"),
    alternateMobile:
      phoneValidation === true
        ? Yup.string()
          .required("Alternate Contact Number is required")
          .min(10, "Must be exactly 10 digits")
          .max(10, "Must be exactly 10 digits")
        : Yup.string(),
    native: Yup.string().required("Native Location is required"),
    preferredLocation: Yup.string().required("Preferred location is required"),
    relevantExperience: Yup.number()
      .typeError("Relevant experience must be a number")
      .required("Relevant experience is required")
      .transform((_, val) => (val ? Number(val) : null)),
    educationalQualification: Yup.string().required("Educational qualification is required"),
    day: Yup.string().notRequired().nullable(),
    month: Yup.string().notRequired().nullable(),
    year: Yup.string().notRequired().nullable(),
    gender: Yup.string().nullable().required("Gender is required"),
    differentlyAbled: Yup.string().required("Differently abled status is required"),
    currentCtc: Yup.number()
      .typeError("Current CTC must be a number")
      .required("Current CTC is required")
      .transform((_, val) => (val ? Number(val) : null)),
    expectedCtc: Yup.number()
      .typeError("Expected CTC must be a number")
      .required("Expected CTC is required")
      .transform((_, val) => (val ? Number(val) : null)),
    noticePeriod: Yup.string().required("Notice period is required"),
    education_gap: Yup.string().required("Education gap is required"),
    career_gap: Yup.string().required("Career gap is required"),
    document_check: Yup.string().required("Document check status is required"),
    offer_details: Yup.string().required("Offer details are required"),
    reloaction_reason: Yup.string().nullable().notRequired(),
    reasonForJobChange: Yup.string().required("Reason for job change is required"),
    candidateProcessed: Yup.string().required("Candidate processed status is required"),
    reason: Yup.string().nullable().notRequired(),
    currentCompanyName: Yup.string().required("Current company name is required"),
    linkedInProfile: Yup.string().required("Linked-In profile is required"),
    panNumber: Yup.string().nullable().notRequired(),

    candidateRecruiterDiscussionRecording: Yup.string()
      .nullable()
      .notRequired(),
    candidateSkillExplanationRecording: Yup.string().nullable().notRequired(),
    candidateMindsetAssessmentLink: Yup.string().nullable().notRequired(),
    candidateAndTechPannelDiscussionRecording: Yup.string()
      .nullable()
      .notRequired(),

    invoiceDate: Yup.string(),
    invoicedValue: Yup.string(),
    joinedDate: Yup.string(),
  });

  const invoiceSchema = Yup.object().shape({
    invoice: Yup.number()
      .test(
        "len",
        "Must be exactly 15 digits",
        (val) => Math.ceil(Math.log10(val + 1)) <= 15,
      )
      .required("Invoice Value is required")
      .nullable(true)
      .transform((_, val) => (val ? Number(val) : null)),
  });

  const noteSchema = Yup.object().shape({
    message: Yup.string().required("Message is required"),
  });

  const dropSchema = Yup.object().shape({
    reason: Yup.string().max(255, 'Maximum 255 characters allowed').required("Reason is required"),
  });

  const {
    register: dropCandidates,
    formState: { errors: dropErrors },
    handleSubmit: dropSubmit,
    reset: dropReset,
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(dropSchema),
  });

  const {
    register: noteCandidates,
    formState: { errors: noteErrors },
    handleSubmit: noteSubmit,
    reset: noteReset,
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(noteSchema),
  });

  const {
    register: invoiceCandidates,
    formState: { errors: invoiceErrors },
    handleSubmit: invoiceSubmit,
    reset: invoicereset,
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(invoiceSchema),
  });

  const {
    register: editCandidates,
    formState: { errors: editErrors, isSubmitting: editIsSubmitting },
    handleSubmit: editSubmit,
    setValue: setEditValue,
    reset: editreset,
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(editSchema),
  });

  const {
    register,
    reset,
    handleSubmit,
    watch,
    formState: { errors, isSubmitting },
    setValue
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const allValues = watch();

  // useEffect(() => {
  //   // Log the current values to the console whenever they change
  //   console.log("Current form values:", allValues);
  // }, [allValues]); 

  useEffect(() => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}admin/userList`,
      data: {},
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
      .then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          setUserName(response.data.data);
        }
      })

      .catch(function (error) {
        console.log(error);
      });
  }, [token]);


  const mobile = sessionStorage.getItem("use");

  const fetchCandidateDetails = async (mobile) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}recruiter/checkCandidateDetailExist`,
        { mobile: mobile.substring(2) },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      if (response.data.status === true) {
        sessionStorage.removeItem("use");

        const candidateData = response.data.data;

        reset({
          requirementId: recruitmentId,
          mobile: mobile.substring(2),
          email: candidateData?.email,
          firstName: candidateData?.firstName,
          lastName: candidateData?.lastName,
          skills: candidateData?.skills,
          experience: candidateData?.experience,
          location: candidateData?.currentLocation,
          candidateProcessed: candidateData?.candidateProcessed,
          native: candidateData?.nativeLocation,
          preferredLocation: candidateData?.preferredLocation,
          relevantExperience: candidateData?.relevantExperience,
          educationalQualification: candidateData?.educationalQualification,
          gender: candidateData?.gender,
          differentlyAbled: candidateData?.differentlyAbled,
          currentCtc: candidateData?.currentCtc,
          expectedCtc: candidateData?.expectedCtc,
          noticePeriod: candidateData?.noticePeriod,
          education_gap: candidateData?.education_gap,
          career_gap: candidateData?.career_gap,
          document_check: candidateData?.document_check,
          offer_details: candidateData?.offer_details,
          reloaction_reason: candidateData?.reloaction_reason,
          reasonForJobChange: candidateData?.reasonForJobChange,
          reason: candidateData?.reason,
          currentCompanyName: candidateData?.currentCompanyName,
        });

        setCandidate({
          mobile: mobile.substring(2),
          email: candidateData?.email,
          firstName: candidateData?.firstName,
          lastName: candidateData?.lastName,
          skills: candidateData?.skills,
          experience: candidateData?.experience,
          location: candidateData?.currentLocation,
          dob: candidateData?.dob,
          candidateProcessed: candidateData?.candidateProcessed,
          native: candidateData?.nativeLocation,
          preferredLocation: candidateData?.preferredLocation,
          relevantExperience: candidateData?.relevantExperience,
          educationalQualification: candidateData?.educationalQualification,
          gender: candidateData?.gender,
          differentlyAbled: candidateData?.differentlyAbled,
          currentCtc: candidateData?.currentCtc,
          expectedCtc: candidateData?.expectedCtc,
          noticePeriod: candidateData?.noticePeriod,
          education_gap: candidate?.education_gap,
          career_gap: candidateData?.career_gap,
          document_check: candidateData?.document_check,
          offer_details: candidateData?.offer_details,
          reloaction_reason: addList.reloaction_reason,
          reasonForJobChange: candidateData?.reasonForJobChange,
          reason: candidateData?.reason,
          candidateRecruiterDiscussionRecording: candidateData?.candidateRecruiterDiscussionRecording,
          candidateSkillExplanationRecording: candidateData?.candidateSkillExplanationRecording,
          candidateMindsetAssessmentLink: candidateData?.candidateMindsetAssessmentLink,
          candidateAndTechPannelDiscussionRecording: candidateData?.candidateAndTechPannelDiscussionRecording,
          currentCompanyName: candidateData?.currentCompanyName,
          freeValue: decode.isEnableFree ? "YES" : decode.isEnablePaid ? "NO" : "YES",
          panNumber: candidateData?.panNumber,
          linkedInProfile: candidateData?.linkedInProfile,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async () => {
    // setCurrerntPage(1);
    // setPage(0);

    const form = filterRef.current;

    if (new URLSearchParams(candidate_search).get("search")) {
      form["search"].value = new URLSearchParams(candidate_search).get("search");
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}admin/viewAllCanditates`,
        {
          page: currerntPage,
          search: `${form["search"].value}`,
          requirementId: sessionStorage.getItem("recruitmentId") !== null
            ? sessionStorage.getItem("recruitmentId")
            : recruitmentId?.id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      if (response.data.status === true) {
        setLoader(false);
        setCandidatesData(response.data.data);
        setCount(response.data.count);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getRequirementName = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}admin/getAllRequirementList`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      if (response.data.status === true) {
        setLoader(false);
        setRequirementName(response.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getClientName = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}admin/getAllClientList`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      if (response.data.status === true) {
        setLoader(false);
        setClientName(response.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setLoader(true);
    setSearch(new URLSearchParams(candidate_search).get("search"));

    if (mobile !== "" && mobile !== null) {
      setState({ ...state, right: true });
      setDataList("ADD");
      fetchCandidateDetails(mobile);
    }

    fetchData();
    getRequirementName();
    getClientName();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    reducerValue,
    token,
    new URLSearchParams(candidate_search).get("search"),
    sessionStorage.getItem("use"),
  ]);

  function updateData(id) {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}recruiter/getAllCandidateStatus`,
      data: {
        id: id,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
      .then(function (response) {
        if (response.data.status === true) {
          var myCandidateStatuses = response.data.data;

          axios({
            method: "post",
            url: `${process.env.REACT_APP_SERVER}admin/viewCandidate`,
            data: {
              id: id,
            },
            headers: {
              "Content-Type": "application/json",
              Authorization: token,
            },
          }).then(function (result) {
            if (result.data.status === true) {
              const updateState = candidatesData.map((item) => {
                if (item.id === id) {
                  return {
                    ...item,
                    candidateDetail: result.data.data.candidateDetail,
                    invoiceValue: result.data.data.invoiceValue,
                    invoicedDate: result.data.data.invoicedDate,
                    joinedDate: result.data.data.joinedDate,
                    statusCode: result.data.data.statusList.statusCode,
                    statusList: result.data.data.statusList,
                    myCandidateStatuses: myCandidateStatuses,
                    droppedReason: result.data.data.droppedReason,
                    ditchReason: result.data.data.ditchReason,
                    creditNoteReason: result.data.data.creditNoteReason,
                  };
                }
                return item;
              });

              setCandidatesData(updateState);
            }
            setLoader(false);
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  function handleAddNotes(values) {
    return new Promise((resolve) => {
      setLoader(true);

      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}recruiter/addCandidateNotes`,
        data: {
          candidateId: candidatesEdit.id,
          message: values.message,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        resolve();
        if (response.data.status === true) {
          handleNotificationCall("success", response.data.message);
          forceUpdate();
          setState({ ...state, right: false });
        } else {
          handleNotificationCall("error", response.data.message);
        }
        setLoader(false);
      });
    });
  }

  const [recruiterId, setRecruiterId] = useState(null);
  const [requirementId, setRequirementId] = useState(null);
  const [clientId, setClientId] = useState(null);

  const handleFromDateChange = (event) => {
    setFromDate(filterRef.current.fromDate.value);
  };

  const handleToDateChange = (event) => {
    setToDate(filterRef.current.toDate.value);
  };

  const resetForm = (e) => {
    filterRef.current.reset();
    setRecruiterId(null);
    setRequirementId(null);
    setClientId(null);
    setSearch("");
    history.push("/app/admin_candidates?search=");
    sessionStorage.removeItem("recruitmentId");
    forceUpdate();
  };

  useEffect(() => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}recruiter/requirementList`,
      data: {
        page: "1",
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setRequirement(response.data.data);
      }
    });
  }, [token]);

  useEffect(() => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}source/viewSourcesList`,
      data: {},
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setSource(response.data.data);
      }
    });
  }, [token]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setCurrerntPage(newPage + 1);
    setLoader(true);

    const form = filterRef.current;
    var data = JSON.stringify({
      page: newPage + 1,
      search: `${form["search"].value}`,
      fromDate: `${form["fromDate"].value}`,
      toDate: `${form["toDate"].value}`,
      recruiterId: recruiterId?.id,
      requirementId:
        sessionStorage.getItem("recruitmentId") !== null
          ? sessionStorage.getItem("recruitmentId")
          : requirementId?.id,
      clientId: clientId?.id,
    });

    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}admin/viewAllCanditates`,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setCandidatesData(response.data.data);
        setCount(response.data.count);
      }

      setLoader(false);
    });
  };

  function getFilterData() {
    sessionStorage.removeItem("recruitmentId");
    setLoader(true);
    // setCurrerntPage(1);
    // setPage(0);
    const form = filterRef.current;
    if (form["fromDate"].value > form["toDate"].value) {
      handleNotificationCall("error", "Check your Selected Dates");
      return
    }
    var data = JSON.stringify({
      page: 1,
      search: `${form["search"].value}`,
      fromDate: `${form["fromDate"].value}`,
      toDate: `${form["toDate"].value}`,
      recruiterId: recruiterId?.id,
      requirementId:
        sessionStorage.getItem("recruitmentId") !== null
          ? sessionStorage.getItem("recruitmentId")
          : requirementId?.id,
      clientId: clientId?.id,
    });

    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}admin/viewAllCanditates`,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
      .then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          setCandidatesData(response.data.data);
          setCount(response.data.count);
        }
      })

      .catch(function (error) {
        console.log(error);
      });
  }

  const [listCanditate, setListCanditate] = useState([]);

  const toggleDrawer = (anchor, open) => (event) => {
    setState({ ...state, [anchor]: open });
  };

  const [open, setOpen] = React.useState(false);
  const [stausOpen, setStatusOpen] = React.useState(false);
  const [stausNewOpen, setStatusNewOpen] = React.useState(false);
  const [dropOpen, setDropOpen] = React.useState(false);
  const [reverseOpen, setReverseOpen] = React.useState(false);
  const [messageOpen, setMessageOpen] = React.useState(false);

  const [resumeOpen, setResumeOpen] = React.useState(false);
  const [cpvOpen, setCpvOpen] = React.useState(false);
  const [vcApproval, setVcApproval] = React.useState(false);
  const [vcData, setVcData] = React.useState([]);
  const [cpvData, setCpvData] = React.useState([]);
  const [matchJDOpen, setMatchJDOpen] = React.useState(false);

  const handleVcApprovalClose = () => {
    setVcApproval(false);
  };

  const handleVcApprovalOpen = (data) => {
    setVcApproval(true);
    setVcData(data)
  };

  const handleResumeClose = () => {
    setResumeOpen(false);
  };

  const handleResumeOpen = () => {
    setResumeOpen(true);
  };

  const handleCPVClose = () => {
    setCpvOpen(false);
  };

  const handleCPVOpen = (item) => {
    setCpvOpen(true);
    setCpvData(item)
  };

  const handleJDClose = () => {
    setMatchJDOpen(false);
    setResumePercentage([])
  };

  const handleJDOpen = () => {
    setMatchJDOpen(true);
  };

  const [candidate, setCandidate] = useState({
    requirementId: "",
    source: "",
    email: "",
    firstName: "",
    lastName: "",
    skills: "",
    location: "",
    experience: null,
    candidateProcessed: "",
    native: "",
    preferredLocation: "",
    relevantExperience: null,
    educationalQualification: "",
    gender: "",
    differentlyAbled: "",
    currentCtc: null,
    expectedCtc: null,
    noticePeriod: "",
    education_gap: "",
    career_gap: "",
    document_check: "",
    offer_details: "",
    reloaction_reason: "",
    reasonForJobChange: "",
    reason: "",
    dob: "",
    candidateRecruiterDiscussionRecording: "",
    candidateSkillExplanationRecording: "",
    candidateMindsetAssessmentLink: "",
    candidateAndTechPannelDiscussionRecording: "",
    freeValue:
      decode.isEnableFree === true
        ? "YES"
        : decode.isEnablePaid === true
          ? "NO"
          : "YES",
    panNumber: "",
    linkedInProfile: "",
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleStatusOpen = () => {
    setStatusOpen(true);
  };

  const handleStatusClose = () => {
    setStatusOpen(false);
  };

  const isExternalAndRestricted = (candidateDetail) => {
    return candidateDetail?.isExternal === "YES" && candidateDetail?.showAllDetails === false;
  };

  const isMailSent = (candidateDetail) => {
    return candidateDetail?.detailsHandler?.isMailSent === true;
  };

  // const checkCandidateDetails = (item) => {
  //   const { candidateDetail } = item;
  //   const { isExternal, showAllDetails, detailsHandler } = candidateDetail;
  //   if (isExternal === "YES" && showAllDetails === false) {
  //     return detailsHandler?.isMailSent === true;
  //   }
  //   return false;
  // };

  // Example usage

  const handleStatusNewOpen = () => {
    setStatusNewOpen(true);
  };

  const handleStatusNewClose = () => {
    setStatusNewOpen(false);
  };

  const handleMessageOpen = () => {
    setMessageOpen(true);
  };

  const handleMessageClose = () => {
    setMessageOpen(false);
  };

  const handleDropOpen = () => {
    setDropOpen(true);
  };

  const handleDropClose = () => {
    setDropOpen(false);
  };

  const handleReverseOpen = () => {
    setReverseOpen(true);
  };

  const handleReverseClose = () => {
    setReverseOpen(false);
  };

  const [dropReasonOpen, setDropReasonOpen] = useState(false);

  const handleDropReasonOpen = () => {
    setDropReasonOpen(true);
    setStatusOpen(false);
  };

  const handleDropReasonClose = () => {
    setDropReasonOpen(false);
  };

  const reasonRef = useRef();

  const [reasonOpen, setReasonOpen] = useState(false);

  const handleReasonOpen = () => {
    setStatusOpen(false);
    setStatusNewOpen(false);
    setReasonOpen(true);
  };

  const handleReasonClose = () => {
    setReasonOpen(false);
  };

  const [changeMessageOpen, setChangeMessageOpen] = useState(false);

  const handleChangeMessageOpen = () => {
    setChangeMessageOpen(true);
    handleStatusClose();
  };

  const handleChangeMessageClose = () => {
    setChangeMessageOpen(false);
  };

  const [view, setView] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // function downloadExel() {
  //   setLoader(true);
  //   const form = filterRef.current;
  //   var data = JSON.stringify({
  //     search: `${form["search"].value}`,
  //     fromDate: `${form["fromDate"].value}`,
  //     toDate: `${form["toDate"].value}`,
  //     recruiterId: recruiterId?.id,
  //     fileDownload: "yes",
  //   });

  //   axios({
  //     method: "post",
  //     url: `${process.env.REACT_APP_SERVER}admin/viewAllCanditates`,
  //     data: data,
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: token,
  //     },
  //   }).then(function (response) {
  //     if (response.data.status === true) {
  //       setLoader(false);
  //       saveAsExcel(response.data.data);
  //     }
  //   });
  // }

  const [recruitmentId, setRecruitmentId] = useState("");

  function handleAdd(values) {
    console.log(values)
    return new Promise((resolve) => {
      if (validation === true) {
      } else {
        setAddList(values);

        axios({
          method: "post",
          url: `${process.env.REACT_APP_SERVER}CC/getRequirement`,
          data: {
            id: recruitmentId,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }).then(function (response) {
          if (response.data.status === true) {
            setRequirementList({
              ...requirementList,
              cand1_name: values.firstName + " " + values.lastName,
              job1_location: response.data.data.jobLocation,
              client1_name: response.data.data.client?.clientName,
              job1_title: response.data.data.requirementName,
              cand1_skills: values.skills,
              job1_experience: response.data.data.experience,
              rec_name: localStorage.getItem("firstName"),
              rec_mobile_no: localStorage.getItem("mobile"),
              req_id: response.data.data.uniqueId,
            });

            CheckAlreadyExit(values);
          }
          resolve();
        });
      }
    });
  }

  function CheckAlreadyExit(addList) {
    var dob = addList.day + "-" + addList.month + "-" + addList.year;

    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}recruiter/candidateExist`,
      data: {
        email: addList.email,
        firstName: addList.firstName,
        lastName: addList.lastName,
        mobile: addList.mobile,
        requirementId: recruitmentId,
        skills: addList.skills,
        sourceId: addList.source,
        isAnswered: candidate.freeValue,
        message: "",
        experience: addList.experience,
        currentLocation: addList.location,
        alternateMobile: addList.alternateMobile,
        preferredLocation: addList.preferredLocation,
        nativeLocation: addList.native,
        relevantExperience: addList.relevantExperience,
        currentCtc: addList.currentCtc,
        expectedCtc: addList.expectedCtc,
        dob:
          addList.day === undefined
            ? ""
            : dob !== "--"
              ? addList.day + "-" + addList.month + "-" + addList.year
              : "",
        noticePeriod: addList.noticePeriod,
        education_gap: addList.education_gap,
        career_gap: addList.career_gap,
        document_check: addList.document_check,
        offer_details: addList.offer_details,
        reloaction_reason: addList.reloaction_reason,
        reasonForJobChange: addList.reasonForJobChange,
        candidateProcessed: addList.candidateProcessed,
        differentlyAbled: addList.differentlyAbled,
        educationalQualification: addList.educationalQualification,
        gender: addList.gender,
        reason: addList.reason,
        candidateRecruiterDiscussionRecording:
          addList.candidateRecruiterDiscussionRecording,
        candidateSkillExplanationRecording:
          addList.candidateSkillExplanationRecording,
        candidateMindsetAssessmentLink: addList.candidateMindsetAssessmentLink,
        candidateAndTechPannelDiscussionRecording:
          addList.candidateAndTechPannelDiscussionRecording,
        currentCompanyName: addList.currentCompanyName,
        sendMessage: "",
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        handleClickOpen();
      }
      // else{
      //   handleNotificationCall("error", response.data.message);

      // }
    });
  }

  function handleEdit(values) {
    return new Promise((resolve) => {

      if (!values.day || !values.month || !values.year) {
        handleNotificationCall("error", "Please select the date of birth properly.");
        return;
      }
      console.log("file:Vijay",file)
      // if (file!=="") {
      //   handleNotificationCall("error", "Please select Resume.");
      //   return;
      // }


      setLoader(true);
      var dob = values.day + "-" + values.month + "-" + values.year;

      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}admin/adminEditCandidate`,
        data: {
          id: candidatesEdit.id,
          email: values.email,
          firstName: values.firstName,
          lastName: values.lastName,
          mobile: values.mobile,
          skills: values.skills,
          experience: values.experience,
          currentLocation: values.location,
          sourceId: values.source,
          invoiceValue: values.invoicedValue,
          invoicedDate: values.invoicedDate,
          joinedDate: values.joinedDate,
          alternateMobile: values.alternateMobile,
          preferredLocation: values.preferredLocation,
          nativeLocation: values.native,
          relevantExperience: values.relevantExperience,
          currentCtc: values.currentCtc,
          expectedCtc: values.expectedCtc,
          dob:
            values.day === undefined
              ? candidatesEdit.dob
              : dob !== "--"
                ? dob
                : candidatesEdit.dob,
          noticePeriod: values.noticePeriod,
          education_gap: values.education_gap,
          career_gap: values.career_gap,
          document_check: values.document_check,
          offer_details: values.offer_details,
          reloaction_reason: values.reloaction_reason,
          reasonForJobChange: values.reasonForJobChange,
          candidateProcessed: values.candidateProcessed,
          differentlyAbled: values.differentlyAbled,
          educationalQualification: values.educationalQualification,
          gender: values.gender,
          reason: values.reason,
          candidateRecruiterDiscussionRecording:
            values.candidateRecruiterDiscussionRecording,
          candidateSkillExplanationRecording:
            values.candidateSkillExplanationRecording,
          candidateMindsetAssessmentLink: values.candidateMindsetAssessmentLink,
          candidateAndTechPannelDiscussionRecording:
            values.candidateAndTechPannelDiscussionRecording,
          hideContactDetails: candidatesEdit.hideContactDetails,
          currentCompanyName: values.currentCompanyName,
          panNumber: values.panNumber,
          linkedInProfile: values.linkedInProfile,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      })
        .then(function (response) {
          if (response.data.status === true) {

            const fileUploadTasks = [
              { file: file, uploadFunction: uploadResume },
              { file: docFile, uploadFunction: updateCandidateDocument },
              { file: profile, uploadFunction: updateCandidatePhoto },
              { file: assessment, uploadFunction: uploadAssessment }
            ];

            fileUploadTasks.forEach(({ file, uploadFunction }) => {
              if (file !== undefined && file.length !== 0) {
                uploadFunction(file, response.data.candidateDetailsId);
              }
            });

            setLoader(false);
            setState({ ...state, right: false });
            handleNotificationCall("success", response.data.message);

            updateData(candidatesEdit.id);
          } else {
            setLoader(false);
            handleNotificationCall("error", response.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    });
  }

  function handleAddList(send) {
    if (!addList.day || !addList.month || !addList.year) {
      handleNotificationCall("error", "Please select the date of birth properly.");
      return;
    }
    console.log(`values: ${addList}`)

    setLoader(true);
    var url = "";
    var data = {};
    var dob = addList.day + "-" + addList.month + "-" + addList.year;

    if (candidate.freeValue === "YES") {
      url = `${process.env.REACT_APP_SERVER}recruiter/addFreeCandidate`;
      data = {
        email: addList.email,
        firstName: addList.firstName,
        lastName: addList.lastName,
        mobile: addList.mobile,
        requirementId: recruitmentId,
        skills: addList.skills,
        sourceId: addList.source,
        isAnswered: candidate.freeValue,
        message: messageRef.current.value,
        experience: addList.experience,
        currentLocation: addList.location,
        alternateMobile: addList.alternateMobile,
        preferredLocation: addList.preferredLocation,
        nativeLocation: addList.native,
        relevantExperience: addList.relevantExperience,
        currentCtc: addList.currentCtc,
        expectedCtc: addList.expectedCtc,
        dob:
          addList.day === undefined
            ? ""
            : dob !== "--"
              ? addList.day + "-" + addList.month + "-" + addList.year
              : "",
        noticePeriod: addList.noticePeriod,
        education_gap: addList.education_gap,
        career_gap: addList.career_gap,
        document_check: addList.document_check,
        offer_details: addList.offer_details,
        reloaction_reason: addList.reloaction_reason,
        reasonForJobChange: addList.reasonForJobChange,
        candidateProcessed: addList.candidateProcessed,
        differentlyAbled: addList.differentlyAbled,
        educationalQualification: addList.educationalQualification,
        gender: addList.gender,
        reason: addList.reason,
        candidateRecruiterDiscussionRecording:
          addList.candidateRecruiterDiscussionRecording,
        candidateSkillExplanationRecording:
          addList.candidateSkillExplanationRecording,
        candidateMindsetAssessmentLink: addList.candidateMindsetAssessmentLink,
        candidateAndTechPannelDiscussionRecording:
          addList.candidateAndTechPannelDiscussionRecording,
        currentCompanyName: addList.currentCompanyName,
        sendMessage: send,
      };
    } else {
      url = `${process.env.REACT_APP_SERVER}recruiter/addCandidate`;
      data = {
        email: addList.email,
        firstName: addList.firstName,
        lastName: addList.lastName,
        mobile: addList.mobile,
        requirementId: recruitmentId,
        skills: addList.skills,
        sourceId: addList.source,
        isAnswered: candidate.freeValue,
        experience: addList.experience,
        currentLocation: addList.location,
        alternateMobile: addList.alternateMobile,
        preferredLocation: addList.preferredLocation,
        nativeLocation: addList.native,
        relevantExperience: addList.relevantExperience,
        currentCtc: addList.currentCtc,
        expectedCtc: addList.expectedCtc,
        dob:
          addList.day === undefined
            ? ""
            : dob !== "--"
              ? addList.day + "-" + addList.month + "-" + addList.year
              : "",
        noticePeriod: addList.noticePeriod,
        education_gap: addList.education_gap,
        career_gap: addList.career_gap,
        document_check: addList.document_check,
        offer_details: addList.offer_details,
        reloaction_reason: addList.reloaction_reason,
        reasonForJobChange: addList.reasonForJobChange,
        candidateProcessed: addList.candidateProcessed,
        differentlyAbled: addList.differentlyAbled,
        educationalQualification: addList.educationalQualification,
        gender: addList.gender,
        reason: addList.reason,
        candidateRecruiterDiscussionRecording:
          addList.candidateRecruiterDiscussionRecording,
        candidateSkillExplanationRecording:
          addList.candidateSkillExplanationRecording,
        candidateMindsetAssessmentLink: addList.candidateMindsetAssessmentLink,
        candidateAndTechPannelDiscussionRecording:
          addList.candidateAndTechPannelDiscussionRecording,
        currentCompanyName: addList.currentCompanyName,
        sendMessage: send,
        panNumber: addList.panNumber,
        linkedInProfile: addList.linkedInProfile,
      };
    }

    axios({
      method: "post",
      url: url,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        handleClose();
        var message = "";

        const fileUploadTasks = [
          { file: file, uploadFunction: uploadResume },
          { file: docFile, uploadFunction: updateCandidateDocument },
          { file: profile, uploadFunction: updateCandidatePhoto },
          { file: assessment, uploadFunction: uploadAssessment }
        ];

        fileUploadTasks.forEach(({ file, uploadFunction }) => {
          if (file !== undefined && file.length !== 0) {
            uploadFunction(file, response.data.candidateDetailsId);
          }
        });

        if (send === true) {
          if (candidate.freeValue === "YES") {
            message = messageRef.current.value;

            window.open(
              "https://api.whatsapp.com/send?phone=+91" +
              addList.mobile +
              "&text=" +
              message +
              "",
            );
          } else {
            message =
              "Hi " +
              requirementList.cand1_name +
              ", Can we chat today about a job opening " +
              localStorage.getItem("firstName") +
              ", " +
              localStorage.getItem("mobile") +
              ", " +
              localStorage.getItem("companyName") +
              ". Always reply by clicking back arrow button/right swipe only.";

            handleMessage(
              response.data.candidate_mobile,
              message,
              response.data.candidateId,
            );
          }
        }

        handleNotificationCall("success", response.data.message);

        forceUpdate();
        setState({ ...state, right: false });
        reset();
      } else {
        handleNotificationCall("error", response.data.message);
      }

      setValidation(false);
      setLoader(false);
    });
  }

  function getCanididateResumeInfo(candidateData, candidateDetail) {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}AI/getCanididateResumeInfo`,
      data: {
        id: candidateData
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setResumeParsedData({
          data: response.data?.data,
          candidateName: candidateDetail?.firstName + " " + candidateDetail?.lastName,
        })
        const responsedData = JSON.stringify(response.data?.data)
        const candidateFullName = candidateDetail?.firstName + " " + candidateDetail?.lastName
        sessionStorage.setItem('candidateResume', responsedData)
        sessionStorage.setItem('candidateName', candidateFullName)
        window.open(`/v1#/app/parsed_resume`, '_blank')
      } else {
        handleNotificationCall("error", response.data.message);
      }
    });
  }

  function resumeExtract() {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}recruiter/extractInfo`,
      data: {},
      headers: {
        "Content-Type": "Application/Jsom",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
      } else {
        handleNotificationCall("error", response.data.message);
      }
    });
  }

  function uploadResume(File, Id) {
    if (File && File?.size >= 25000000) {
      handleNotificationCall("error", "Maximum File Size Limit 25mb");
      return
    }
    var FormData = require("form-data");
    var data = new FormData();
    data.append("resume", File);
    data.append("id", Id);
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}recruiter/updateCandidateResume`,
      data: data,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
      } else {
        handleNotificationCall("error", response.data.message);
      }
    });
  }

  function updateCandidateDocument(File, Id) {
    if (File && File?.size >= 25000000) {
      handleNotificationCall("error", "Maximum File Size Limit 25mb");
      return;
    }

    var FormData = require("form-data");
    var data = new FormData();
    data.append("document", File);
    data.append("id", Id);
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}recruiter/updateCandidateDocument`,
      data: data,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
      } else {
        handleNotificationCall("error", response.data.message);
      }
    });
  }

  function updateCandidatePhoto(File, Id) {
    if (File && File?.size >= 10485760) {
      handleNotificationCall("error", "Maximum File Size Limit 10mb");
      return;
    }

    var FormData = require("form-data");
    var data = new FormData();
    data.append("image", File);
    data.append("id", Id);
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}recruiter/updateCandidatePhoto`,
      data: data,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
      } else {
        handleNotificationCall("error", response.data.message);
      }
    });
  }

  function uploadAssessment(File, Id) {
    var FormData = require("form-data");
    var data = new FormData();
    data.append("file", File);
    data.append("id", Id);
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}recruiter/updateCandidateMindSetAssessment`,
      data: data,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        handleNotificationCall("success", response.data.message);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    });
  }

  function handleMessage(mobile, message, candidateId) {
    var url = "";

    if (candidate.freeValue === "YES") {
      url = `${process.env.REACT_APP_SERVER}recruiter/changeYesCadidateStatus`;
    } else {
      url = `${process.env.REACT_APP_SERVER}chat/sendTemplateMessage`;
    }

    axios({
      method: "post",
      url: url,
      data: {
        candidateId: candidateId,
        phone_number: mobile,
        template_name: "first_message",
        vars: [
          requirementList.cand1_name,
          requirementList.rec_name,
          requirementList.rec_mobile_no,
          localStorage.getItem("companyName"),
        ],
        message: message,
        candidate_name: requirementList.cand1_name,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        if (response.data.isNew === true) {
          getmessageIni();
        }

        setLoader(false);
      } else {
        handleNotificationCall("error", response.data.message);
      }

      handleStatusClose();
      handleStatusNewClose();
      setLoader(false);
    });
  }

  function changeStatus(send, message, status, candidateId) {
    setLoader(true);
    const template_name =
      shortList.statusCode === 303
        ? "1st_interview_round"
        : shortList.statusCode === 3031
          ? "initial_interview_rounds"
          : shortList.statusCode === 304
            ? status === "Schedule Another Interview"
              ? "initial_interview_rounds"
              : status === "Schedule Final Interview"
                ? "final_interview_round"
                : status === "Send Document"
                  ? "document_collect"
                  : ""
            : shortList.statusCode === 3041
              ? "document_collect"
              : shortList.statusCode === 305
                ? "document_collected"
                : shortList.statusCode === 306
                ? "salary_breakup_shared_confirmation"
                : shortList.statusCode === 307
                  ? "offer_released_confirmation"
                  : shortList.statusCode === 308
                    ? status === "Joining Confirmation"
                      ? "joining_confirmation"
                      : ""
                    : "";

    const vars =
      shortList.statusCode === 308
        ? [
          shortList.cand_name,
          shortList.job_id,
          shortList.rec_name,
          shortList.rec_mobile_no,
          localStorage.getItem("companyName"),
        ]
        : [
          shortList.cand_name,
          shortList.job_id,
          shortList.rec_name,
          shortList.rec_mobile_no,
          localStorage.getItem("companyName"),
        ];

    var url = "";
    if (shortList.free === "YES") {
      url = `${process.env.REACT_APP_SERVER}recruiter/changeYesCadidateStatus`;
    } else {
      url = `${process.env.REACT_APP_SERVER}chat/sendTemplateMessage`;
    }

    axios({
      method: "post",
      url: url,
      data: {
        sendMessage: send,
        candidateId: candidateId,
        phone_number: shortList.cand_mobile,
        template_name: template_name,
        vars: vars,
        message: message,
        candidate_name: shortList.cand_name,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        if (response.data.isNew === true) {
          getmessageIni();
        }

        if (shortList.free === "YES" && send === true) {
          window.open(
            "https://api.whatsapp.com/send?phone=" +
            shortList.cand_mobile +
            "&text=" +
            message +
            "",
          );
        }

        setLoader(false);
        updateData(candidateId);
        handleNotificationCall("success", response.data.message);
        setState({ ...state, right: false });
      } else {
        setLoader(false);
        handleNotificationCall("error", response.data.message);
      }

      handleStatusClose();
      handleStatusNewClose();
    });
  }

  function joinedStatus() {
    setLoader(true);
    var url = `${process.env.REACT_APP_SERVER}recruiter/updateJoinedStatus`;

    axios({
      method: "post",
      url: url,
      data: {
        candidateId: shortList.id,
        joinedDate: joiningRef.current.value,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        handleStatusClose();
        handleStatusNewClose();
        updateData(shortList.id);
        handleNotificationCall("success", response.data.message);
      } else {
        handleNotificationCall("error", response.data.message);
        setLoader(false);
      }
    });
  }

  function creditNoteStatus() {
    setLoader(true);
    var url = `${process.env.REACT_APP_SERVER}admin/updateCrediNoteStatus`;

    axios({
      method: "post",
      url: url,
      data: {
        candidateId: shortList.id,
        creditNoteReason: reasonRef.current.value,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        handleStatusClose();
        handleReasonClose();
        updateData(shortList.id);
        handleNotificationCall("success", response.data.message);
      } else {
        handleNotificationCall("error", response.data.message);
        setLoader(false);
      }
    });
  }

  function updateJoiningDitchedStatus() {
    setLoader(true);
    var url = `${process.env.REACT_APP_SERVER}recruiter/updateJoiningDitchedStatus`;

    axios({
      method: "post",
      url: url,
      data: {
        candidateId: shortList.id,
        ditchReason: reasonRef.current.value,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        handleStatusClose();
        handleReasonClose();
        updateData(shortList.id);
        handleNotificationCall("success", response.data.message);
      } else {
        handleNotificationCall("error", response.data.message);
        setLoader(false);
      }
    });
  }

  function InvoicedStatus(values) {
    setLoader(true);
    var url = `${process.env.REACT_APP_SERVER}recruiter/updateInvoicedStatus`;

    return new Promise((resolve) => {
      axios({
        method: "post",
        url: url,
        data: {
          candidateId: shortList.id,
          invoice: values.invoice,
          invoicedDate: invoiceRef.current.value,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        if (response.data.status === true) {
          updateData(shortList.id);
          handleStatusClose();
          resolve();
          handleNotificationCall("success", response.data.message);
        } else {
          handleNotificationCall("error", response.data.message);
          setLoader(false);
        }
      });
    });
  }

  function DropStatus(values) {
    setLoader(true);
    var url = `${process.env.REACT_APP_SERVER}recruiter/DropCandidate`;

    return new Promise((resolve) => {
      axios({
        method: "post",
        url: url,
        data: {
          id: shortList.id,
          droppedReason: values.reason,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        if (response.data.status === true) {
          updateData(shortList.id);
          handleDropReasonClose();
          resolve();
          handleNotificationCall("success", response.data.message);
        } else {
          handleNotificationCall("error", response.data.message);
          setLoader(false);
        }
      });
    });
  }

  function changeStcStatus() {
    setLoader(true);

    var url = `${process.env.REACT_APP_SERVER}recruiter/updateStcStatus`;

    axios({
      method: "post",
      url: url,
      data: {
        id: shortList.id,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        updateData(shortList.id);
        handleChangeMessageClose();
        handleNotificationCall("success", response.data.message);
      } else {
        handleNotificationCall("error", response.data.message);
        setLoader(false);
      }
    });
  }

  function OfferDeclineStatus(values) {
    var url = `${process.env.REACT_APP_SERVER}recruiter/updateOfferDeclineStatus`;
    setLoader(true);
    return new Promise((resolve) => {
      axios({
        method: "post",
        url: url,
        data: {
          candidateId: shortList.id,
          offerDeclinedReason: reasonRef.current.value,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        if (response.data.status === true) {
          updateData(shortList.id);
          handleReasonClose();
          resolve();
          handleNotificationCall("success", response.data.message);
        } else {
          handleNotificationCall("error", response.data.message);
          setLoader(false);
        }
      });
    });
  }

  const ExistCheck = (e) => {
    if (recruitmentId !== "") {
      CheckExitAlready(recruitmentId, e);
    } else {
      handleNotificationCall("error", "Select Requirement");
    }
  };

  function CheckExitAlready(recruitmentId, e) {
    var data = {};
    var url = "";

    if (e.target.name === "email") {
      data = {
        requirementId: recruitmentId,
        email: e.target.value,
      };
      url = `${process.env.REACT_APP_SERVER}recruiter/checkEmailExist`;
    } else {
      data = {
        requirementId: recruitmentId,
        mobile: e.target.value,
      };
      url = `${process.env.REACT_APP_SERVER}recruiter/checkMobileExist`;
    }

    axios({
      method: "post",
      url: url,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        handleNotificationCall("error", response.data.message);
      }
    });
  }

  function cvMatchingPercentage(id, requirementId) {

    setMatchLoading(true)
    const isRequirementIdExist = resumePercentage.some(item => item.requirementId === requirementId);
    if (isRequirementIdExist) {
      setMatchLoading(false)
      handleNotificationCall("error", "Requirement already exists in the match list.");
      return;
    }

    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}AI/jdMatcher`,
      data: {
        id: id,
        requirementId: requirementId
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then((response) => {
      if (response.data.status === true) {

        const previousPercentage = [...resumePercentage];

        const newPercentageItem = {
          description: response.data?.data,
          requirementName: response.data?.requirementName,
          requirementId: response.data?.requirementId
        };

        previousPercentage.push(newPercentageItem);

        setResumePercentage(previousPercentage);
      } else if (response.data.status === false) {
        handleNotificationCall("error", response.data.message);
      }
      setMatchLoading(false)
    });
  }

  const removePercentage = (requirementIdToRemove) => {
    const updatedPercentage = resumePercentage.filter(item => item.requirementId !== requirementIdToRemove);
    setResumePercentage(updatedPercentage);
  };

  function handleShow(values, name) {
    setLoader(true);
    if (name === "EDIT") {
      setDataList("EDIT");
    } else if (name === "VIEW") {
      setDataList("VIEW");
    } else {
      setDataList("NOTES");
    }

    if (name !== "NOTES") {
      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}admin/viewCandidate`,
        data: {
          id: values,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      })
        .then(function (response) {
          if (response.data.status === true) {
            setCandidateView({
              ...candidateView,
              id: response.data.data.id,
              chatId: response.data.chatUser?.id,
              email: response.data.data.candidateDetail?.email,
              mobile: response.data.data.candidateDetail?.mobile,
              cc:
                response.data.data.requirement?.recruiter?.firstName +
                " " +
                response.data.data.requirement?.recruiter?.lastName,
              firstName: response.data.data.candidateDetail?.firstName,
              lastName: response.data.data.candidateDetail?.lastName,
              skills: response.data.data.candidateDetail?.skills,
              clientName: response.data.data.requirement?.client?.clientName,
              requirementName: response.data.data.requirement?.requirementName,
              statusCode: response.data.data.statusList?.statusCode,
              source: response.data.data.source?.name,
              invoiceValue: response.data.data.invoiceValue,
              requiremenUniqueId: response.data.data.requirement?.uniqueId,
              candidateUniqueId: response.data.data.uniqueId,
              isAnswered: response.data.data.isAnswered,
              currentLocation:
                response.data.data.candidateDetail?.currentLocation,
              preferredLocation:
                response.data.data.candidateDetail?.preferredLocation,
              nativeLocation:
                response.data.data.candidateDetail?.nativeLocation,
              experience: response.data.data.candidateDetail?.experience,
              relevantExperience:
                response.data.data.candidateDetail?.relevantExperience,
              currentCtc: response.data.data.candidateDetail?.currentCtc,
              expectedCtc: response.data.data.candidateDetail?.expectedCtc,
              dob: response.data.data.candidateDetail?.dob,
              noticePeriod: response.data.data.candidateDetail?.noticePeriod,
              education_gap: response.data.data.candidateDetail?.education_gap,
              career_gap: response.data.data.candidateDetail?.career_gap,
              document_check: response.data.data.candidateDetail?.document_check,
              offer_details: response.data.data.candidateDetail?.offer_details,
              reloaction_reason: response.data.data.candidateDetail?.reloaction_reason,
              reasonForJobChange:
                response.data.data.candidateDetail?.reasonForJobChange,
              reason: response.data.data.candidateDetail?.reason,
              candidateProcessed:
                response.data.data.candidateDetail?.candidateProcessed,
              differentlyAbled:
                response.data.data.candidateDetail?.differentlyAbled,
              educationalQualification:
                response.data.data.candidateDetail?.educationalQualification,
              gender: response.data.data.candidateDetail?.gender,
              alternateMobile:
                response.data.data.candidateDetail?.alternateMobile,
              resume: response.data.data.candidateDetail?.resume,
              document: response.data.data.candidateDetail?.document,
              photo: response.data.data.candidateDetail?.photo,
              candidateRecruiterDiscussionRecording:
                response.data.data.candidateRecruiterDiscussionRecording,
              candidateSkillExplanationRecording:
                response.data.data.candidateSkillExplanationRecording,
              candidateMindsetAssessmentLink:
                response.data.data.candidateMindsetAssessmentLink,
              candidateAndTechPannelDiscussionRecording:
                response.data.data.candidateAndTechPannelDiscussionRecording,
              currentCompanyName:
                response.data.data.candidateDetail?.currentCompanyName,
              mainId: response.data.data.mainId,
              isCandidateCpv: response.data.data.isCandidateCpv,
              panNumber: response.data.data.candidateDetail?.panNumber,
              linkedInProfile: response.data.data.candidateDetail?.linkedInProfile,
              isSendCpv: response.data.data.requirement?.isSendCpv,
            });

            setCandidatesEdit({
              ...candidatesEdit,
              id: response.data.data.id,
              requirementName: response.data.data.requirement?.requirementName,
              email: response.data.data.candidateDetail?.email,
              mobile: response.data.data.candidateDetail?.mobile?.substring(2),
              firstName: response.data.data.candidateDetail?.firstName,
              lastName: response.data.data.candidateDetail?.lastName,
              skills: response.data.data.candidateDetail?.skills,
              source: response.data.data.source?.id,
              invoicedDate: response.data.data.invoicedDate,
              joinedDate: response.data.data.joinedDate,
              invoiceValue: response.data.data.invoiceValue,
              currentLocation:
                response.data.data.candidateDetail?.currentLocation,
              preferredLocation:
                response.data.data.candidateDetail?.preferredLocation,
              nativeLocation:
                response.data.data.candidateDetail?.nativeLocation,
              experience: response.data.data.candidateDetail?.experience,
              relevantExperience:
                response.data.data.candidateDetail?.relevantExperience,
              currentCtc: response.data.data.candidateDetail?.currentCtc,
              expectedCtc: response.data.data.candidateDetail?.expectedCtc,
              dob: response.data.data.candidateDetail?.dob,
              noticePeriod: response.data.data.candidateDetail?.noticePeriod,
              education_gap: response.data.data.candidateDetail?.education_gap,
              career_gap: response.data.data.candidateDetail?.career_gap,
              document_check: response.data.data.candidateDetail?.document_check,
              offer_details: response.data.data.candidateDetail?.offer_details,
              reloaction_reason: response.data.data.candidateDetail?.reloaction_reason,
              reasonForJobChange:
                response.data.data.candidateDetail?.reasonForJobChange,
              reason: response.data.data.candidateDetail?.reason,
              candidateProcessed:
                response.data.data.candidateDetail?.candidateProcessed,
              differentlyAbled:
                response.data.data.candidateDetail?.differentlyAbled,
              educationalQualification:
                response.data.data.candidateDetail?.educationalQualification,
              alternateMobile: response.data.data.candidateDetail?.alternateMobile?.substring(
                2,
              ),
              resume: response.data.data.candidateDetail?.resume,
              document: response.data.data.candidateDetail?.document,
              photo: response.data.data.candidateDetail?.photo,
              gender: response.data.data.candidateDetail?.gender,
              candidateRecruiterDiscussionRecording:
                response.data.data.candidateRecruiterDiscussionRecording,
              candidateSkillExplanationRecording:
                response.data.data.candidateSkillExplanationRecording,
              candidateMindsetAssessmentLink:
                response.data.data.candidateMindsetAssessmentLink,
              candidateAndTechPannelDiscussionRecording:
                response.data.data.candidateAndTechPannelDiscussionRecording,
              mainId: response.data.data.mainId,
              recruiterId: response.data.data.recruiterId,
              currentCompanyName:
                response.data.data.candidateDetail?.currentCompanyName,
              hideContactDetails: response.data.data.hideContactDetails,
              panNumber: response.data.data.candidateDetail?.panNumber,
              linkedInProfile: response.data.data.candidateDetail?.linkedInProfile,
              showAllDetails: response.data.data.candidateDetail?.showAllDetails,
            });

            setState({ ...state, right: true });

            setLoader(false);
          } else {
            setLoader(false);
          }
        })
        .catch(function (error) {
          console.log(error);
        });

      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}recruiter/getAllCandidateStatus`,
        data: {
          id: values,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      })
        .then(function (response) {
          if (response.data.status === true) {
            setListCanditate(response.data.data);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      setCandidatesEdit({
        ...candidatesEdit,
        id: values,
      });

      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}recruiter/viewCandidateNotes`,
        data: {
          candidateId: values,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        if (response.data.status === true) {
          setCandidatesNote(response.data.data);
          setState({ ...state, right: true });
          setLoader(false);
        }
      });
    }
  }

  function dropConfirmation(id) {
    setLoader(true);
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}recruiter/DropCandidate`,
      data: {
        id: id,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setDropOpen(false);
        updateData(id);
      } else {
        handleNotificationCall("error", response.data.message);
        setLoader(false);
      }
    });
  }

  function reverseConfirmation(id) {
    setLoader(true);
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}admin/resetStatus`,
      data: {
        id: id,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setReverseOpen(false);
        setLoader(false);
        updateData(id);
        handleNotificationCall("success", response.data.message);
      } else {
        handleNotificationCall("error", response.data.message);
        setLoader(false);
      }
    });
  }

  function sendMessage(candidateId, mobile, message, candidate_name, list) {
    setLoader(true);

    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}chat/sendTemplateMessage`,
      data: {
        candidateId: candidateId,
        phone_number: mobile,
        template_name: "general_message",
        vars: [
          candidate_name,
          list.rec_name,
          list.rec_mobile_no,
          localStorage.getItem("companyName"),
        ],
        message: message,
        candidate_name: candidate_name,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
      .then(function (response) {
        if (response.data.status === true) {
          if (response.data.isNew === true) {
            getmessageIni();
          }

          setLoader(false);
          handleMessageClose();
          handleNotificationCall("success", response.data.message);
        } else {
          setLoader(false);
          handleNotificationCall("error", response.data.message);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  function getmessageIni() {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}auth/getMyWallet`,
      data: {},
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        localStorage.setItem(
          "WalletValue",
          response.data.data.remainingMessages,
          { sameSite: "strict", secure: true },
        );
        window.dispatchEvent(new Event("storage"));
      }
    });
  }

  const list = (anchor) =>
    dataList === "EDIT" ? (
      <>
        <Edit
          setEditValue={setEditValue}
          setValidation={setValidation}
          validation={validation}
          editSubmit={editSubmit}
          handleEdit={handleEdit}
          setCandidatesEdit={setCandidatesEdit}
          candidatesEdit={candidatesEdit}
          editCandidates={editCandidates}
          editIsSubmitting={editIsSubmitting}
          editErrors={editErrors}
          toggleDrawer={toggleDrawer}
          source={source}
          setFile={setFile}
          setDocFile={setDocFile}
          setProfile={setProfile}
          file={file}
          docFile={docFile}
          profile={profile}
          setAssessment={setAssessment}
          assessment={assessment}
          days={days}
          months={months}
          years={years}
          setDay={setDay}
          setMonth={setMonth}
          setYear={setYear}
          date={date}
          month={month}
          year={year}
          setPhoneValidation={setPhoneValidation}
          show={
            candidatesEdit.recruiterId === decode.recruiterId ? true : false
          }
        />
      </>
    ) : dataList === "ADD" ? (
      <>
        <Add
          setValue={setValue}
          setValidation={setValidation}
          validation={validation}
          handleAddList={handleAddList}
          register={register}
          source={source}
          recruitmentList={recruitmentList}
          handleClose={handleClose}
          errors={errors}
          setLoader={setLoader}
          toggleDrawer={toggleDrawer}
          setRecruitmentList={setRecruitmentList}
          requirementList={requirementList}
          handleSubmit={handleSubmit}
          handleAdd={handleAdd}
          requirement={requirement}
          isSubmitting={isSubmitting}
          open={open}
          messageRef={messageRef}
          reset={reset}
          setCandidate={setCandidate}
          candidate={candidate}
          setFile={setFile}
          setDocFile={setDocFile}
          setProfile={setProfile}
          file={file}
          docFile={docFile}
          profile={profile}
          setAssessment={setAssessment}
          assessment={assessment}
          setRecruitmentId={setRecruitmentId}
          recruitmentId={recruitmentId}
          days={days}
          months={months}
          years={years}
          setDay={setDay}
          setMonth={setMonth}
          setYear={setYear}
          setPhoneValidation={setPhoneValidation}
          setHideContactDetails={setHideContactDetails}
          hideContactDetails={hideContactDetails}
          ExistCheck={ExistCheck}
          requirementId={"true"}
        />
      </>
    ) : dataList === "VIEW" ? (
      <>
        <View
          candidateView={candidateView}
          toggleDrawer={toggleDrawer}
          listCanditate={listCanditate}
          candidatesEdit={candidatesEdit}
          setCandidateView={setCandidateView}
        />
      </>
    ) : (
      <>
        <Note
          toggleDrawer={toggleDrawer}
          candidatesNote={candidatesNote}
          noteCandidates={noteCandidates}
          noteErrors={noteErrors}
          handleAddNotes={handleAddNotes}
          noteSubmit={noteSubmit}
        />
      </>
    );

  const HeaderElements = () => (
    <>
      <Grid className={classes.HeaderElements}>
        Total : {count}
      </Grid>
    </>
  );

  const renderHeaderWithIcon = (label, icon) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {icon}
      <span style={{ marginLeft: '5px' }}>{label}</span>
    </div>
  );

  const table_options = {
    textLabels: {
      body: {
        noMatch: "Oops! Matching record could not be found",
      },
    },
    search: false,
    pagination: false,
    sort: false,
    selectableRows: "none",
    filter: false,
    print: false,
    download: false,
    customToolbar: () => <HeaderElements />,
    onFilterChange: (changedColumn, filterList) => { },
    filterType: "dropdown",
    rowsPerPage: 50,
    // rowsExpanded: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    expandableRows: true,
    expandableRowsHeader: false,
    expandableRowsOnClick: true,
    responsive: mobileQuery === true ? "vertical" : "standard",
    renderExpandableRow: (rowData, rowMeta) => {
      const list = candidatesData[rowMeta.rowIndex];

      return (
        <React.Fragment>
          <tr>
            <td colSpan={16}>
              <Bar title="Candidates" list={list} />
            </td>
          </tr>
        </React.Fragment>
      );
    },
    page: page,
  };

  const components = {
    ExpandButton: function (props) {
      return <ExpandButton {...props} />;
    },
  };

  // function getSheetData(data, header) {
  //   var fields = Object.keys(data[0]);
  //   var sheetData = data.map(function (row) {
  //     return fields.map(function (fieldName) {
  //       return row[fieldName] ? row[fieldName] : "";
  //     });
  //   });
  //   sheetData.unshift(header);
  //   return sheetData;
  // }

  // async function saveAsExcel(data) {
  //   let header = [
  //   "S.No",
  //   "Requirement Name",
  //   "Client Coordinator",
  //   "Recruiter",
  //   "Candidate Name",
  //   "Email",
  //   "Mobile",
  //   "Gender",
  //   "Current Location",
  //   "Preferred Location",
  //   "Native Location",
  //   "Total Years of Experience",
  //   "Relevant Experience",
  //   "Current CTC",
  //   "Expected CTC",
  //   "DOB",
  //   "Notice Period",
  //   "Reason for Job Change",
  //   "Candidate Attended",
  //   "Differently Abled",
  //   "Educational Qualification",
  //   "Posted Date",
  //   ];

  //   XlsxPopulate.fromBlankAsync().then(async (workbook) => {
  //     const sheet1 = workbook.sheet(0);
  //     const sheetData = getSheetData(data, header);
  //     const totalColumns = sheetData[0].length;

  //     sheet1.cell("A1").value(sheetData);
  //     const range = sheet1.usedRange();
  //     const endColumn = String.fromCharCode(64 + totalColumns);
  //     sheet1.row(1).style("bold", true);
  //     sheet1.range("A1:" + endColumn + "1").style("fill", "BFBFBF");
  //     range.style("border", true);
  //     return workbook.outputAsync().then((res) => {
  //       saveAs(
  //         res,
  //         `Candidates_${moment(new Date()).format("DD_MM_YYYY_HH_mm")}.xlsx`,
  //       );
  //     });
  //   });
  // }

  return (
    <>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Candidates" />
        </Grid>

        <Grid item xs={3} sm={5} md={4} lg={6} className={classes.drawerClose}>
          <div className={classes.lgButton}>
            <Button
              variant="contained"
              size="small"
              startIcon={<AddCircleIcon />}
              className={classes.margin}
              color="primary"
              onClick={(e) => {
                setDataList("ADD");
                reset();
                setCandidate({
                  ...candidate,
                  requirementId: "",
                  source: "",
                  email: "",
                  firstName: "",
                  lastName: "",
                  skills: "",
                  location: "",
                  experience: null,
                  gender: "",
                  differentlyAbled: "",
                  candidateProcessed: "",
                  native: "",
                  preferredLocation: "",
                  relevantExperience: null,
                  educationalQualification: "",
                  currentCtc: null,
                  expectedCtc: null,
                  noticePeriod: "",
                  education_gap: "",
                  career_gap: "",
                  document_check: "",
                  offer_details: "",
                  reloaction_reason: "",
                  reasonForJobChange: "",
                  reason: "",
                  dob: "",
                  candidateRecruiterDiscussionRecording: "",
                  candidateSkillExplanationRecording: "",
                  candidateMindsetAssessmentLink: "",
                  candidateAndTechPannelDiscussionRecording: "",
                  freeValue:
                    decode.isEnableFree === true
                      ? "YES"
                      : decode.isEnablePaid === true
                        ? "NO"
                        : "YES",
                  panNumber: "",
                  linkedInProfile: "",
                });
                setPhoneValidation(false);
                setRecruitmentId("");
                setState({ ...state, right: true });
                setValidation(false);
                setFile([]);
                setDocFile([]);
                setProfile([]);
                setAssessment([]);
              }}
            >
              Add New Candidate
            </Button>
          </div>

          <div className={classes.smButton}>
            <Button
              variant="contained"
              size="small"
              startIcon={<AddCircleIcon />}
              className={classes.margin}
              color="primary"
              onClick={(e) => {
                setDataList("ADD");
                reset();
                setState({ ...state, right: true });
                setValidation(false);
              }}
            >
              Add
            </Button>
          </div>

          <SwipeableDrawer
            anchor="right"
            open={state["right"]}
            onClose={toggleDrawer("right", false)}
            onOpen={toggleDrawer("right", true)}
            classes={{
              paper:
                dataList === "VIEW" || dataList === "NOTES"
                  ? classes.drawer
                  : classes.clientDrawer,
            }}
          >
            {list("right")}
          </SwipeableDrawer>
        </Grid>
      </Grid>

      <form
        ref={filterRef}
        onSubmit={(e) => {
          e.preventDefault();
          getFilterData();
        }}
      >
        <Grid container spacing={2} className={classes.filterGap}>
          <TextField
            label="Search"
            type="text"
            name="search"
            placeholder="Enter Candidate Unique ID/Name/Email/Mobile (eg: 91XXXXXXXXXX)"
            InputLabelProps={{ shrink: true }}
            value={search !== null ? search : ""}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
            className={classes.searchWidth}
          />

          <Autocomplete
            className={classes.filterFullWidth}
            options={requirementName}
            getOptionLabel={(option) =>
              option.requirementName + " (" + option.uniqueId + ")"
            }
            // size="small"
            value={requirementId}
            onChange={(event, value) => {
              setRequirementId(value);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                name="requirementId"
                label="Requirement"
                size="small"
                InputLabelProps={{ shrink: true }}
                type="text"
              />
            )}
          />
          {decode.companyType !== "COMPANY" &&
            <Autocomplete
              className={classes.filterFullWidth}
              options={clientName}
              getOptionLabel={(option) =>
                option.clientName + " (" + option.uniqueId + ")"
              }
              value={clientId}
              onChange={(event, value) => setClientId(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="clientId"
                  label="Project"
                  InputLabelProps={{ shrink: true }}
                  type="text"
                />
              )}
            />
          }

          <Autocomplete
            options={userName}
            className={classes.filterFullWidth}
            getOptionLabel={(option) => {
              const roleName = option.user?.role?.roleName;
              const firstName = option.firstName;
              const lastName = option.lastName;
              let label = `${firstName} ${lastName}`;
              if (roleName) {
                label += ` (${roleName})`;

                if (roleName === 'SUBVENDOR') {
                  label = label.replace('(SUBVENDOR)', `(${option?.companyName})`);
                } else if (roleName === 'CLIENTCOORDINATOR') {
                  label = label.replace('(CLIENTCOORDINATOR)', '(Hiring Manager)');
                }
              }

              return label;
            }}
            value={recruiterId}
            onChange={(event, value) => setRecruiterId(value)}
            renderInput={(params) => (
              <TextField
                {...params}
                name="recruiterId"
                label="Recruiter"
                InputLabelProps={{ shrink: true }}
                type="text"
              />
            )}
          />

          <TextField
            name="fromDate"
            label="From"
            InputLabelProps={{ shrink: true }}
            className={classes.filterWidth}
            type="date"
            defaultValue={fromDate}
            onChange={handleFromDateChange}
          />

          <TextField
            name="toDate"
            label="To"
            InputLabelProps={{ shrink: true }}
            type="date"
            defaultValue={toDate}
            onChange={handleToDateChange}
            className={classes.filterWidth}
          />

          <div className={classes.buttons}>
            <Button
              variant="contained"
              size="small"
              color="primary"
              type="submit"
            >
              Search
            </Button>
            <Button
              variant="contained"
              size="small"
              color="secondary"
              onClick={() => resetForm()}
            >
              Reset
            </Button>
          </div>
        </Grid>
      </form>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MUIDataTable
            options={table_options}
            components={components}
            columns={[
              {
                name: "S.No",
              },
              {
                name: "Actions",
              },
              {
                name: "Chats",
              },
              {
                name: "Status",
              },
              {
                name: "Candidate Name",
              },
              {
                name: "Email ID / Mobile",
              },

              {
                name: "Requirement Name",
              },
              {
                name: decode.companyType === "COMPANY" ? "Hiring Manager" : "Client Coordinator",
              },
              {
                name: "Recruiter Name",
              },

              {
                name: "Resume",
              },
              {
                name: "View Candidate",
              },
              {
                name: "View CPV",
              },
              {
                name: "Posted Date",
              },
            ]}
            data={candidatesData.map((item, index) => {
              return [
                <>
                  {currerntPage !== 0
                    ? 10 * currerntPage - 10 + index + 1
                    : index + 1}
                </>,
                <Actions
                  index={index}
                  item={item}
                  activeIndex={activeIndex}
                  handleMenuClick={handleMenuClick}
                  anchorEl={anchorEl}
                  reset={reset}
                  editreset={editreset}
                  noteReset={noteReset}
                  setCandidateList={setCandidateList}
                  handleMessageOpen={handleMessageOpen}
                  candidateList={candidateList}
                  handleDropOpen={handleDropOpen}
                  handleDropReasonOpen={handleDropReasonOpen}
                  handleReverseOpen={handleReverseOpen}
                  handleShow={handleShow}
                  setFile={setFile}
                  setDocFile={setDocFile}
                  setProfile={setProfile}
                  setAssessment={setAssessment}
                  setPhoneValidation={setPhoneValidation}
                  handleUse={handleUse}
                  shortList={shortList}
                  setShortList={setShortList}
                />,
                <div className={classes.candidateTableChatContainer}>
                  <img
                    className={classes.candidateTableChatImage}
                    src={chatSVGicon}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleShow(item.id, "NOTES")
                      noteReset();
                      setCandidatesData(prevCandidates =>
                        prevCandidates.map(user =>
                          user.id === item.id
                            ? { ...user, candidateNotes: [] }
                            : user
                        )
                      );

                      // fetchData();
                    }}
                    alt='chat_img'
                  />
                  {item.candidateNotes.length > 0 &&
                    <span
                      className={classes.candidateTableChatCount}
                    >
                      {item.candidateNotes.length}
                    </span>
                  }
                </div>,
                item.statusCode && (
                  <Grid >
                    {isExternalAndRestricted(item.candidateDetail) ? (
                      isMailSent(item.candidateDetail) ? (
                        <div>Mail has been sent</div>
                      ) : (
                        <div>
                          Waiting for Approval
                        </div>
                      )
                    ) : (
                      <>
                        {item.recruiter.user.roleName === "SUBCONTRACT" ?
                          <VendorStatus
                            list={item}
                            handleStatusOpen={handleStatusOpen}
                            handleStatusNewOpen={handleStatusNewOpen}
                            setValidation={setValidation}
                            setShortList={setShortList}
                            shortList={shortList}
                            setView={setView}
                            view={view}
                            invoicereset={invoicereset}

                          />
                          :
                          <Status
                            list={item}
                            handleStatusOpen={handleStatusOpen}
                            handleStatusNewOpen={handleStatusNewOpen}
                            setValidation={setValidation}
                            setShortList={setShortList}
                            shortList={shortList}
                            setView={setView}
                            view={view}
                            invoicereset={invoicereset}
                          />
                        }
                      </>
                    )}
                  </Grid>
                ),

                <Grid container row spacing={2} className={classes.externalIconContainer} data-candidatename={item.candidateDetail?.firstName + " " + item.candidateDetail?.lastName}>
                  {item.recruiter?.user.roleName === "SUBVENDOR" ? (
                    <Avatar
                      alt="Profile"
                      src={FreelancerAvatarIcon}
                      className={classes.externalIcon}
                    />
                  ): item.recruiter?.user.roleName === "SUBCONTRACT" ? (
                    <Avatar
                      alt="Profile"
                      src={VendorAvatarIcon}
                      className={classes.externalIcon}
                    />
                  ):(<></>)}
                  <div>
                    {item.candidateDetail?.firstName +
                      " " +
                      item.candidateDetail?.lastName}
                    <br /> {" (" + item.uniqueId + ")"}
                  </div>
                  {item.candidateDetail?.isExternal === "YES" && item.candidateDetail?.showAllDetails === false ? (
                    item.candidateDetail?.detailsHandler?.isMailSent === true ?
                      <>
                        <Avatar
                          alt="mail-send-img"
                          src={mailSendImg}
                          className={classes.mailSendSuccessIcon}
                        />
                      </>
                      :
                      <div
                        onMouseEnter={handleAnimationMouseHover}
                        onMouseLeave={handleAnimationMouseLeave}
                        onClick={() => handleVcApprovalOpen(item)}
                        style={{ width: 35, height: 35 }} // Adjust size as needed
                      >
                        <Lottie
                          lottieRef={lottieRef}
                          animationData={lockanimation}
                          loop={false}
                          autoplay={false}
                        />
                      </div>
                  ) : (
                    ""
                  )}
                </Grid>,
                item.mainId === decode.mainId ? (
                  <>
                    {item.candidateDetail?.email + " /"} <br />
                    {"91 " + item.candidateDetail?.mobile.slice(2)}
                  </>
                ) : item.hideContactDetails !== true ? (
                  <>

                    {item.candidateDetail?.email + " /"} <br />
                    {"91 " + item.candidateDetail?.mobile.slice(2)}
                  </>
                ) : (
                  ""
                ),
                <>
                  {item.requirement?.requirementName} <br />
                  {" (" + item.requirement?.uniqueId + ")"}
                  {item.recruiter?.user.roleName === "SUBVENDOR" ?
                    <>
                      <br />
                      <div style={{ background: 'transparent', borderRadius: '300px', padding: "0.1rem 0.4rem 0.1rem 0", display: "flex", alignItems: "center", gap: "0.2rem" }}>
                        <img src={gold_coin} style={{ width: '18px', height: "18px" }} alt="coin" />
                        <span style={{ color: "#1c13ff" }}>{item.requirement.cvShareValue}</span>{'/'} <br />
                        <span style={{ color: "#000" }}>{item.requirement.cvInterviewDoneValue}</span>{'/'} <br />
                        <span style={{ color: "#399918" }}>{item.requirement.cvJoinValue}</span>
                      </div>
                    </>
                    :
                    item.recruiter?.user.roleName === "SUBCONTRACT"?
                    <>
                      <br />
                      <div style={{ background: 'transparent', borderRadius: '300px', padding: "0.1rem 0.4rem", display: "flex", alignItems: "center", gap: "0.2rem" }}>
                          <img src={invoice_bill_percentage} style={{ width: '18px', height: "18px" }} alt="invoice" />
                        <span style={{ color: "#0a5b41" }}>{item.requirement.joinedSharePercentage} Percent</span>
                      </div>
                    </>
                    :
                    <></>
                  }
                </>,
                item.requirement?.client?.handler?.firstName + " " + item.requirement?.client?.handler?.lastName,
                item.recruiter?.firstName + " " + item.recruiter?.lastName,
                <>
                  {item.candidateDetail?.resume !==
                    `${process.env.REACT_APP_AWS_BUCKET_URL}` ? (
                    <>
                      <Grid container className={classes.space}>
                        <Grid item xs className={classes.toolAlign}>
                          <Tooltip
                            title="View Resume"
                            placement="bottom"
                            aria-label="view"
                          >
                            <DescriptionIcon
                              className={classes.toolIcon}
                              onClick={() => {
                                handleResumeOpen();
                                setFile([
                                  {
                                    url: item.candidateDetail?.resume,
                                  },
                                ]);
                              }}
                            />
                          </Tooltip>
                          {/* <Tooltip         title="Downlaod Resume"         placement="bottom"         aria-label="downlaod"       > 
  <a href={item.candidateDetail?.resume} download>  <GetAppIcon className={classes.toolIcon} />    </a>      
</Tooltip>      */}
                        </Grid>
                      </Grid>
                    </>
                  ) : (
                    "No Resume Found"
                  )}
                </>,
                <Tooltip
                  title="View Candidate"
                  placement="bottom"
                  aria-label="view"
                >
                  <ViewIcon
                    onClick={(e) => {
                      handleShow(item.id, "VIEW");
                    }}
                    className={classes.toolIcon}
                  />
                </Tooltip>,
                <Tooltip
                  title="View CPV"
                  placement="bottom"
                  aria-label="view"
                >
                  <IoMailOpenOutline
                    onClick={(e) => {
                      handleCPVOpen(item);
                    }}
                    className={classes.cpvIcon}
                  />
                </Tooltip>,
                // <Tooltip
                //   title="Match JD"
                //   placement="bottom"
                //   aria-label="view"
                // >
                //   <div className={classes.toolIcon+" "+classes.resumeUploadParent} 
                //     onClick={(e) => {
                //       handleJDOpen();
                //       cvMatchingPercentage(item.id);
                //       setCandidMatchId(item.id);
                //     }}>
                //     %
                //   </div>
                // </Tooltip>,
                // <Tooltip
                //   title="Get Resume Info"
                //   placement="bottom"
                //   aria-label="view"
                // >
                //   <div className={classes.toolIcon+" "+classes.resumeUploadParent} 
                //     onClick={(e) => {
                //       getCanididateResumeInfo(item.candidateDetailId,item.candidateDetail);
                //     }}>
                //     i
                //   </div>
                // </Tooltip>,
                moment(item.createdAt).format("DD-MM-YYYY"),
              ];
            })}
          />

          <Grid container spacing={2} className={classes.pagination}>
            <TablePagination
              rowsPerPageOptions={[50]}
              component="div"
              count={count}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
            />
          </Grid>
        </Grid>
      </Grid>

      <Message
        setState={setState}
        state={state}
        candidateList={candidateList}
        decode={decode}
        sendMessage={sendMessage}
        handleMessageOpen={handleMessageOpen}
        messageOpen={messageOpen}
        handleMessageClose={handleMessageClose}
      />

      <Dialogs
        handleStatusClose={handleStatusClose}
        handleStatusNewClose={handleStatusNewClose}
        validation={validation}
        stausOpen={stausOpen}
        stausNewOpen={stausNewOpen}
        changeStatus={changeStatus}
        shortList={shortList}
        view={view}
        setView={setView}
        invoiceCandidates={invoiceCandidates}
        invoiceErrors={invoiceErrors}
        invoiceSubmit={invoiceSubmit}
        InvoicedStatus={InvoicedStatus}
        joinedStatus={joinedStatus}
        creditNoteStatus={creditNoteStatus}
        updateJoiningDitchedStatus={updateJoiningDitchedStatus}
        OfferDeclineStatus={OfferDeclineStatus}
        joiningRef={joiningRef}
        invoiceRef={invoiceRef}
        saveOnly={saveOnly}
        setSaveOnly={setSaveOnly}
        dropCandidates={dropCandidates}
        dropErrors={dropErrors}
        dropSubmit={dropSubmit}
        dropReset={dropReset}
        DropStatus={DropStatus}
        handleDropReasonClose={handleDropReasonClose}
        dropReasonOpen={dropReasonOpen}
        handleDropReasonOpen={handleDropReasonOpen}
        changeMessageOpen={changeMessageOpen}
        handleChangeMessageClose={handleChangeMessageClose}
        changeStcStatus={changeStcStatus}
        handleChangeMessageOpen={handleChangeMessageOpen}
        reasonRef={reasonRef}
        handleReasonOpen={handleReasonOpen}
        reasonOpen={reasonOpen}
        handleReasonClose={handleReasonClose}
      />

      <DropReasonDialogs
        dropCandidates={dropCandidates}
        dropErrors={dropErrors}
        dropSubmit={dropSubmit}
        dropReset={dropReset}
        DropStatus={DropStatus}
        handleDropReasonClose={handleDropReasonClose}
        dropReasonOpen={dropReasonOpen}
      />

      {/* <ResumeDialog
        resume={file}
        resumeOpen={resumeOpen}
        handleResumeClose={handleResumeClose}
      /> */}
      <CPVFormView
        setLoader={setLoader}
        handleNotificationCall={handleNotificationCall}
        candidateView={candidateView}
        cpvOpen={cpvOpen}
        cpvData={cpvData}
        handleCPVClose={handleCPVClose}
      />
      <ReactPdfDialog
        resume={file}
        resumeOpen={resumeOpen}
        handleResumeClose={handleResumeClose}
      />
      <FreelancerCandidatesApproval
        handleVcApprovalClose={handleVcApprovalClose}
        handleNotificationCall={handleNotificationCall}
        setLoader={setLoader}
        vcData={vcData}
        vcApproval={vcApproval}
        updateData={fetchData}
      />
      {/* <MatchJDDialog
        resumePercentage={resumePercentage}
        requirementName={requirementName}
        matchLoading={matchLoading}
        jDOpen={matchJDOpen}
        handleJDClose={handleJDClose}
        candidMatchId={candidMatchId}
        cvMatchingPercentage={cvMatchingPercentage}
        removePercentage={removePercentage}
      /> */}

      <Drop
        handleDropClose={handleDropClose}
        dropOpen={dropOpen}
        dropConfirmation={dropConfirmation}
        candidateList={candidateList}
      />

      <Reverse
        handleReverseClose={handleReverseClose}
        reverseOpen={reverseOpen}
        reverseConfirmation={reverseConfirmation}
        candidateList={candidateList}
      />


      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
